import {fetcher} from 'src/global/fetcher';

export const GraphicsServices = {
  getAllAreaData: (areaId: string) => fetcher.get(`production/stats/${areaId}`),
};
